/* eslint no-shadow: ["error", { "allow": ["state"] }] */

export const namespaced = true;

export const state = {
  returnTo: null,
};

export const actions = {
  setReturnTo({ commit }, returnTo) {
    return commit('SET_RETURNTO', returnTo);
  },
};

export const mutations = {
  SET_RETURNTO(state, returnTo) {
    state.returnTo = returnTo;
  },
};

export const getters = {
  getReturnTo: () => state.returnTo,
};
